// #1292: 時間指定チケットの枠 (日時) 表示フォーマット。
// 枠の date/startTime は店舗 local (JST 固定) で保存されているため、表示も JST 基準。

/** "2026-08-13" → ロケール依存の "8/13(火)" 等。 */
export function formatSlotDate(date: string, locale: string): string {
  if (!date) return ''
  const d = new Date(`${date}T00:00:00+09:00`)
  if (Number.isNaN(d.getTime())) return date
  return d.toLocaleDateString(locale, { month: 'numeric', day: 'numeric', weekday: 'short' })
}

/** 枠の日時をまとめて "8/13(火) 15:00" 形式に。date が無ければ空文字。 */
export function formatSlotDateTime(
  date: string | null | undefined,
  startTime: string | null | undefined,
  locale: string,
): string {
  if (!date) return ''
  const d = formatSlotDate(date, locale)
  return startTime ? `${d} ${startTime}` : d
}

/**
 * #1487 所要時間を人が読む形にする ("90分" / "2時間" / "1時間30分")。
 *
 * 分だけで「180分」と出すと、旅行者は自分で割り算することになる。
 * バスの時刻を気にしている人に暗算をさせない。
 */
export function formatDuration(
  minutes: number | null | undefined,
  t: (key: string, params?: Record<string, string>) => string,
): string {
  if (!minutes || minutes <= 0) return ''
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return t('experience.durationMinutes', { n: String(m) })
  if (m === 0) return t('experience.durationHours', { n: String(h) })
  return t('experience.durationHoursMinutes', { h: String(h), m: String(m) })
}

/**
 * #1487 枠の時刻を「10:00 〜 11:30」に。終わりが決まっていなければ「10:00 開始」。
 *
 * **終了時刻が無いのに範囲で出さない。** 滞在自由の商品に終わりを書くと嘘になる。
 */
export function formatSlotRange(
  startTime: string | null | undefined,
  endTime: string | null | undefined,
  t: (key: string, params?: Record<string, string>) => string,
): string {
  if (!startTime) return ''
  if (!endTime) return t('experience.slotOpenEnded', { start: startTime })
  return t('experience.slotRange', { start: startTime, end: endTime })
}
